var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassroomIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.734,
    height: 17.293,
    viewBox: "0 0 18.734 17.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.367,0,0,2.162V3.6L9.367,1.441,18.734,3.6V2.162ZM5.044,4.323A13.679,13.679,0,0,0,.45,5.269l-.45.2v11.1H8.129a1.425,1.425,0,0,0,2.477,0h8.129V5.472l-.45-.2a13.679,13.679,0,0,0-4.593-.946,12.461,12.461,0,0,0-4.323.856A12.461,12.461,0,0,0,5.044,4.323Zm0,1.441a11.977,11.977,0,0,1,3.6.7v8.016a11.675,11.675,0,0,0-3.6-.63,11.313,11.313,0,0,0-3.6.63V6.462A11.074,11.074,0,0,1,5.044,5.764Zm8.646,0a11.074,11.074,0,0,1,3.6.7v8.016a11.313,11.313,0,0,0-3.6-.63,11.675,11.675,0,0,0-3.6.63V6.462A11.977,11.977,0,0,1,13.69,5.764Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomIconBlue);
export default __webpack_public_path__ + "static/media/classroom-icon-blue.b789ef75362da00de4f4792a29c120ad.svg";
export { ForwardRef as ReactComponent };